import _ from 'lodash';
import React, { Component } from 'react';
import toastr from '../../toastr';

export default class PartsRequestCollection extends Component {
  state = {
    data: [{ op: '', qty: '', txt: '' }],
  };

  addLineItem = () => {
    const data = [...this.state.data, { op: '', qty: '', txt: '' }];

    this.setState(
      {
        data,
      },
      () => {
        document.getElementById(`tc-op-${data.length - 1}`).focus();
      }
    );
  };

  /* op/qty/txt collections are submitted to D3/QM delimited by ~ */
  get() {
    return {
      op: _.map(this.state.data, 'op').join('~'),
      qty: _.map(this.state.data, 'qty').join('~'),
      txt: _.map(this.state.data, 'txt').join('~'),
    };
  }

  /* This single event handler keeps the state in sync with the entire parts
     request table. It does so by parsing the target's name property, which
     follows the form tc-key-item (see renderRows()).
  */
  handleChange = event => {
    const value = event.target.value;
    let [, key, item] = event.target.id.split('-'); // eslint-disable-line
    item = parseInt(item, 10);

    // clear any input errors
    document.getElementById(event.target.id).style.border = '';

    // Minimize mutations
    this.setState(prevState => {
      return {
        data: [
          ...prevState.data.slice(0, item),
          {
            ...prevState.data[item],
            [key]: value,
          },
          ...prevState.data.slice(item + 1),
        ],
      };
    });
  };

  removeLineItem = item => {
    // Maintain at least 1 line item - clear on delete
    if (this.state.data.length === 1) {
      // Clear any errors
      ['op', 'qty', 'txt'].forEach(input => {
        document.getElementById(`tc-${input}-0`).style.border = '';
      });

      this.setState(
        {
          data: [{ op: '', qty: '', txt: '' }],
        },
        document.getElementById('tc-op-0').focus()
      );

      return;
    }

    const data = [...this.state.data];
    data.splice(item, 1);

    this.setState(
      {
        data,
      },
      () => {
        this.validate(false);
      }
    );
  };

  validate(SHOW_TOASTER_ON_INVALID = true) {
    let valid = true;
    const positiveInt = /^[1-9][0-9]*$/;

    for (let i = 0; i < this.state.data.length; i++) {
      const { op, qty, txt } = this.state.data[i];
      const opStyle = document.getElementById(`tc-op-${i}`).style;
      const qtyStyle = document.getElementById(`tc-qty-${i}`).style;
      const txtStyle = document.getElementById(`tc-txt-${i}`).style;

      opStyle.border = positiveInt.test(op) ? '' : ((valid = false), '1px solid red');
      qtyStyle.border = positiveInt.test(qty) ? '' : ((valid = false), '1px solid red');
      txtStyle.border = !!txt.trim() ? '' : ((valid = false), '1px solid red');
    }

    if (!valid && SHOW_TOASTER_ON_INVALID) {
      toastr.error('Invalid Line Item', 'Please correct errors in red.');
    }

    return valid;
  }

  renderRows = () => {
    const rows = [];
    for (let i = 0; i < this.state.data.length; i++) {
      rows.push(
        <tr key={i}>
          <td className="lineItem">{i + 1}</td>
          <td>
            <input type="text" id={`tc-op-${i}`} value={this.state.data[i].op} onChange={this.handleChange} />
          </td>
          <td>
            <input type="text" id={`tc-qty-${i}`} value={this.state.data[i].qty} onChange={this.handleChange} />
          </td>
          <td>
            <input type="text" id={`tc-txt-${i}`} value={this.state.data[i].txt} onChange={this.handleChange} />
          </td>
          <td style={{ textAlign: 'center' }}>
            <button
              type="button"
              className="btn btn-xs btn-danger"
              tabIndex="-1"
              onClick={() => {
                this.removeLineItem(i);
              }}
            >
              <i className="zmdi zmdi-close zmdi-hc-lg" />
            </button>
          </td>
        </tr>
      );
    }

    return rows;
  };

  render() {
    return (
      <div>
        <table className="table parts-request-table">
          <thead>
            <tr>
              <th width="5%" style={{ textAlign: 'center' }}>
                #
              </th>
              <th width="15%">Operation</th>
              <th width="15%">Part Quantity</th>
              <th width="60%">Part Text</th>
              <th width="5%">Actions</th>
            </tr>
          </thead>
          <tbody>{this.renderRows()}</tbody>
        </table>

        <button type="button" className="btn btn-primary btn-sm" onClick={this.addLineItem}>
          <i className="zmdi zmdi-collection-plus zmdi-hc-sm" /> Add Line Item
        </button>
      </div>
    );
  }
}
